import Link from "next/link";

/**
 * Horn-Hub-Marke: Bildmarke (abgerundetes Quadrat in Primärfarbe mit „H") plus
 * Schriftzug „HORN AI Hub". Eine Quelle für Login und Seitenleiste.
 * Mit `href` als Link (Seitenleiste), ohne `href` als reine Marke (Login).
 * Feste Klassen je Größe, nie zusammengesetzt (Plan-Regel 5).
 */
export function Marke({ groesse, href, schriftzugAbSm = false }: { groesse: "klein" | "gross"; href?: string; schriftzugAbSm?: boolean }) {
  // `schriftzugAbSm` (nur Größe klein): unter `sm` nur die Bildmarke (Platz für das Dev-Menü in der Kopfzeile); der Link behält den Namen per aria-label.
  const inhalt =
    groesse === "gross" ? (
      <>
        <span
          className="flex-none size-9 inline-flex justify-center items-center rounded-lg bg-primary text-primary-foreground text-lg font-bold"
          aria-hidden="true"
        >
          H
        </span>
        <span className="text-base whitespace-nowrap" aria-hidden="true">
          <span className="font-bold text-foreground">HORN</span>{" "}
          <span className="font-normal text-primary">AI Hub</span>
        </span>
      </>
    ) : (
      <>
        <span
          className="flex-none size-7 inline-flex justify-center items-center rounded-md bg-primary text-primary-foreground text-sm font-bold"
          aria-hidden="true"
        >
          H
        </span>
        <span className={schriftzugAbSm ? "hidden sm:inline text-sm whitespace-nowrap" : "text-sm whitespace-nowrap"} aria-hidden="true">
          <span className="font-bold text-foreground">HORN</span>{" "}
          <span className="font-normal text-primary">AI Hub</span>
        </span>
      </>
    );

  if (href) {
    return (
      <Link
        className="flex-none inline-flex items-center gap-x-2.5 rounded-md focus:outline-hidden focus:opacity-80"
        href={href}
        aria-label="HORN AI Hub"
      >
        {inhalt}
      </Link>
    );
  }
  return (
    <span className="flex-none inline-flex items-center gap-x-2.5" role="img" aria-label="HORN AI Hub">
      {inhalt}
    </span>
  );
}
